import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';
import { AppAbility } from './ability';

Vue.use(abilitiesPlugin, AppAbility);
